module.exports = __webpack_public_path__ + "static/img/5.36a86ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/5.png
// module id = sgo9
// module chunks = 0